export const actions = {
  GWS_ADD_USER: 'GWS_ADD_USER',
  GWS_DELETE_USER: 'GWS_DELETE_USER',
  GWS_PWD_RESET: 'GWS_PWD_RESET',
  GWS_DISABLE_USER: 'GWS_DISABLE_USER',
  GWS_DISABLE_USER_MFA: 'GWS_DISABLE_USER_MFA',
  GWS_ENABLE_USER: 'GWS_ENABLE_USER', // This is not a probe task name, as DISABLE_USER is used. This is just an alternate name used to import the render body dynamically
  GWS_REVOKE_SESSIONS: 'GWS_REVOKE_SESSIONS',
  GWS_MANAGE_GROUPS: 'GWS_MANAGE_GROUPS',
  GWS_MANAGE_LICENSE: 'GWS_MANAGE_LICENSE',
}
